import React from "react";
import TopNav from "./TopNav";
import Footer from "./Footer";
import { motion } from "framer-motion";

export default function PageLayout({ children, navVariant = "solid", withFooter = true }) {
  return (
    <div className="min-h-screen flex flex-col">
      <TopNav variant={navVariant} />
      <motion.main
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="flex-1 pt-16 md:pt-20"
      >
        {children}
      </motion.main>
      {withFooter && <Footer />}
    </div>
  );
}
